import { useState } from 'react'
import { Plus, Info } from 'lucide-react'
import { useDocumentTitle } from '@/shared/hooks/use-document-title'
import { CampaniaCreateForm } from '@/modules/multichannel/components/CampaniaCreateForm'

export function CampaniaCreate() {
  useDocumentTitle('Nueva Campaña')
  const [showInfo, setShowInfo] = useState(false)

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="mb-6">
        <div className="flex items-center">
          <h1 className="text-3xl font-bold tracking-tight flex items-center gap-2">
            <Plus className="h-6 w-6" />
            Nueva Campaña
          </h1>
          <button
            onClick={() => setShowInfo(!showInfo)}
            className="text-muted-foreground hover:text-foreground transition-colors ml-2"
          >
            <Info className="h-5 w-5" />
          </button>
          {showInfo && (
            <span className="text-muted-foreground ml-2 text-sm animate-in slide-in-from-left-2 duration-200">
              Crea una nueva campaña de mailing completando todos los campos requeridos
            </span>
          )}
        </div>
      </div>

      {/* Formulario */}
      <CampaniaCreateForm />
    </div>
  )
}
